(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[663],{

/***/ 24544:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/adobe-premiere-pro",
      function () {
        return __webpack_require__(91491);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 91491:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ AdobePremiereProPage; }
});

// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/styled-components/dist/styled-components.browser.esm.js
var styled_components_browser_esm = __webpack_require__(82740);
// EXTERNAL MODULE: ./src/layouts/MarketingLayout.tsx + 19 modules
var MarketingLayout = __webpack_require__(71876);
// EXTERNAL MODULE: ../../node_modules/@air/zephyr/dist/zephyr.esm.js + 90 modules
var zephyr_esm = __webpack_require__(55164);
// EXTERNAL MODULE: ../../node_modules/next/image.js
var next_image = __webpack_require__(96577);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./src/old-marketing/components/Container.tsx + 1 modules
var Container = __webpack_require__(29654);
// EXTERNAL MODULE: ../../node_modules/framer-motion/dist/framer-motion.es.js + 37 modules
var framer_motion_es = __webpack_require__(77665);
// EXTERNAL MODULE: ./src/hooks/useRefScrollProgress.ts
var useRefScrollProgress = __webpack_require__(91143);
;// CONCATENATED MODULE: ./src/old-marketing/components/heros/templates/AdobeSplashHeroTemplateImage.tsx





var AdobeSplashHeroTemplateImage = function() {
    var ref = (0,useRefScrollProgress/* useRefScrollProgress */.J)({
        offset: -0.1
    }), ref1 = ref.ref, start = ref.start, end = ref.end;
    var scrollYProgress = (0,framer_motion_es/* useViewportScroll */.ME)().scrollYProgress;
    var layer1YPos = (0,framer_motion_es/* useTransform */.Hm)(scrollYProgress, [
        start,
        end
    ], [
        100,
        0
    ]);
    var layer1YPosAnimation = (0,framer_motion_es/* useSpring */.q_)(layer1YPos, {
        stiffness: 200,
        damping: 20
    });
    var layer2YPos = (0,framer_motion_es/* useTransform */.Hm)(scrollYProgress, [
        start,
        end
    ], [
        300,
        0
    ]);
    var layer2YPosAnimation = (0,framer_motion_es/* useSpring */.q_)(layer2YPos, {
        stiffness: 200,
        damping: 20
    });
    var layer2ScaleAnimation = (0,framer_motion_es/* useTransform */.Hm)(scrollYProgress, [
        start,
        end
    ], [
        0.9,
        1
    ]);
    var layer3YPos = (0,framer_motion_es/* useTransform */.Hm)(scrollYProgress, [
        start,
        end
    ], [
        200,
        0
    ]);
    var layer3YPosAnimation = (0,framer_motion_es/* useSpring */.q_)(layer3YPos, {
        stiffness: 200,
        damping: 20
    });
    var easterEggYPos = (0,framer_motion_es/* useTransform */.Hm)(scrollYProgress, [
        start,
        end
    ], [
        200,
        0
    ]);
    var easterEggYPosAnimation = (0,framer_motion_es/* useSpring */.q_)(easterEggYPos, {
        stiffness: 200,
        damping: 20
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(zephyr_esm/* Box */.xu, {
        tx: {
            width: "100%",
            maxWidth: 1160
        },
        ref: ref1,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(zephyr_esm/* Box */.xu, {
            tx: {
                zIndex: 1,
                position: "relative",
                pb: "51.2%"
            },
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(zephyr_esm/* Box */.xu, {
                    as: framer_motion_es/* motion.div */.ww.div,
                    tx: {
                        position: "absolute",
                        top: "2%",
                        left: "19.4%",
                        width: "68.4%"
                    },
                    style: {
                        y: layer1YPosAnimation
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                        height: 482.5,
                        src: "/assets/marketing/adobe-splash-template-1.png",
                        width: 793
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(zephyr_esm/* Box */.xu, {
                    as: framer_motion_es/* motion.div */.ww.div,
                    tx: {
                        position: "absolute",
                        top: "51.8%",
                        left: "6.2%",
                        width: "32.9%"
                    },
                    style: {
                        scale: layer2ScaleAnimation,
                        y: layer2YPosAnimation
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                        height: 292,
                        src: "/assets/marketing/adobe-splash-template-2.png",
                        width: 382.5
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(zephyr_esm/* Box */.xu, {
                    as: framer_motion_es/* motion.div */.ww.div,
                    tx: {
                        position: "absolute",
                        top: "64.3%",
                        left: "76.3%",
                        width: "16.75%"
                    },
                    style: {
                        y: layer3YPosAnimation
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                        height: 197,
                        src: "/assets/marketing/adobe-splash-template-3.png",
                        width: 194.5
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(zephyr_esm/* Box */.xu, {
                    as: framer_motion_es/* motion.div */.ww.div,
                    tx: {
                        zIndex: -1,
                        position: "absolute",
                        top: "32.6%",
                        left: "9.5%",
                        width: "17.6%"
                    },
                    style: {
                        y: layer3YPosAnimation
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                        height: 207,
                        src: "/assets/marketing/adobe-splash-template-4.svg",
                        width: 207
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(zephyr_esm/* Box */.xu, {
                    as: framer_motion_es/* motion.div */.ww.div,
                    tx: {
                        zIndex: -1,
                        position: "absolute",
                        top: "56.3%",
                        right: "7.5%",
                        width: "6.1%"
                    },
                    style: {
                        y: layer3YPosAnimation
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                        height: 77,
                        src: "/assets/marketing/adobe-splash-template-5.svg",
                        width: 82
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(zephyr_esm/* Box */.xu, {
                    as: framer_motion_es/* motion.div */.ww.div,
                    tx: {
                        zIndex: -1,
                        position: "absolute",
                        top: "47.6%",
                        right: "5%",
                        width: "1.9%"
                    },
                    style: {
                        y: layer2YPosAnimation
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                        height: 22,
                        src: "/assets/marketing/adobe-splash-template-6.svg",
                        width: 24
                    })
                }),
                 false && /*#__PURE__*/ 0
            ]
        })
    });
};

// EXTERNAL MODULE: ./src/old-marketing/components/Section.tsx
var Section = __webpack_require__(32999);
// EXTERNAL MODULE: ./src/old-marketing/utils/buttonLinkRenderer.tsx
var buttonLinkRenderer = __webpack_require__(78214);
;// CONCATENATED MODULE: ./src/old-marketing/components/heros/templates/AdobeSplashHeroTemplate.tsx







var AdobeSplashHeroTemplate = function(param) {
    var content = param.content, title = param.title;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(zephyr_esm/* Box */.xu, {
                tx: {
                    zIndex: -1,
                    position: "absolute",
                    height: "100%",
                    width: "100%",
                    overflow: "hidden"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(zephyr_esm/* Box */.xu, {
                    tx: {
                        zIndex: -1,
                        position: "absolute",
                        top: "23.2vw",
                        left: "-30vw",
                        width: "250vw"
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                        height: 1678,
                        src: "/assets/marketing/adobe-splash-background-image-1.svg",
                        width: 3612
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Section/* Section */.$, {
                tx: {
                    pt: [
                        176,
                        176,
                        176
                    ],
                    pb: [
                        80,
                        156,
                        156
                    ],
                    overflow: "visible"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container/* Container */.W, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(zephyr_esm/* Box */.xu, {
                            tx: {
                                maxWidth: 782,
                                mx: "auto",
                                mb: 80,
                                textAlign: "center"
                            },
                            children: [
                                title && /*#__PURE__*/ (0,jsx_runtime.jsx)(zephyr_esm/* Text */.xv, {
                                    as: "h1",
                                    tx: {
                                        marginBottom: "clamp(24px, 2.7vw, 40px)",
                                        color: "jay050",
                                        fontSize: "clamp(40px, 5vw, 72px)"
                                    },
                                    dangerouslySetInnerHTML: {
                                        __html: title
                                    },
                                    variant: "text-heading-72"
                                }),
                                content && /*#__PURE__*/ (0,jsx_runtime.jsx)(zephyr_esm/* Text */.xv, {
                                    as: "p",
                                    tx: {
                                        color: "jay150",
                                        marginBottom: 56,
                                        fontSize: "clamp(18px, 2.2vw, 32px)"
                                    },
                                    variant: "text-ui-32",
                                    children: content
                                }),
                                (0,buttonLinkRenderer/* buttonLinkRenderer */.w)({
                                    children: "Chat with sales",
                                    href: "#demo",
                                    size: "large",
                                    type: "external"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(AdobeSplashHeroTemplateImage, {})
                    ]
                })
            })
        ]
    });
};
AdobeSplashHeroTemplate.templateKey = "adobe-splash-hero-template";

// EXTERNAL MODULE: ./src/old-marketing/utils/sectionRenderer.tsx + 23 modules
var sectionRenderer = __webpack_require__(68063);
;// CONCATENATED MODULE: ./src/pages/adobe-premiere-pro.tsx





var GlobalStyles = (0,styled_components_browser_esm/* createGlobalStyle */.vJ)({
    body: {
        backgroundColor: "black",
        overflowX: "hidden"
    }
});
var __N_SSG = true;
function AdobePremiereProPage(param) {
    var adobePremiereProPage = param.adobePremiereProPage;
    var ref;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(GlobalStyles, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(AdobeSplashHeroTemplate, {
                content: "Air for Adobe Premiere Pro",
                title: "Remote video collaboration, solved."
            }),
            adobePremiereProPage === null || adobePremiereProPage === void 0 ? void 0 : (ref = adobePremiereProPage.sections) === null || ref === void 0 ? void 0 : ref.map(function(section, index) {
                return (0,sectionRenderer/* sectionRenderer */.E)(section, index, false);
            })
        ]
    });
};
AdobePremiereProPage.layout = MarketingLayout/* MarketingLayout */.z;


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [512,851,276,497,478,664,63,774,888,179], function() { return __webpack_exec__(24544); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);